import React, { useState } from 'react';
import { SectionWrapper } from './Shared';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Realmente funciona si tengo más de 50 años?',
    a: 'Absolutamente. El protocolo se basa en fisiología humana básica. De hecho, los hombres de 50+ suelen ver los cambios más dramáticos porque su margen de mejora hormonal es mayor.'
  }, {
    q: '¿Necesito ir a un gimnasio comercial?',
    a: 'No. Aunque es ideal, el Bonus #3 está diseñado para que puedas obtener resultados increíbles solo con un par de mancuernas o incluso con tu propio peso corporal en casa.'
  }, {
    q: '¿Tengo que dejar de comer lo que me gusta?',
    a: "No es una dieta de privación. Te enseñamos a ser un 'Arquitecto de Carbohidratos'. Aprenderás cuándo comer lo que te gusta para que se convierta en músculo, no en grasa."
  }, {
    q: '¿Es este programa solo para hombres en USA?',
    a: 'El contenido es universal, aunque las guías de compra están optimizadas para tiendas como Costco o Whole Foods comunes en EE. UU., los principios funcionan en cualquier lugar.'
  }, {
    q: '¿Qué pasa si ya estoy en TRT?',
    a: 'Este programa es el complemento perfecto. Optimizar tu nutrición y entrenamiento hará que tu terapia médica funcione 10 veces mejor con dosis menores.'
  }];
  return <SectionWrapper className="bg-prime-dark border-y border-white/5" data-id="element-34">
      <div className="text-center mb-16" data-id="element-35">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-36">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-37">
        {faqs.map((faq, idx) => <div key={idx} className="bg-prime-card border border-white/10 rounded-lg overflow-hidden transition-colors hover:border-prime-gold/30" data-id="element-38">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-39">
              <span className="font-bold text-white text-lg pr-8" data-id="element-40">{faq.q}</span>
              {openIndex === idx ? <Minus className="w-5 h-5 text-prime-gold flex-shrink-0" data-id="element-41" /> : <Plus className="w-5 h-5 text-prime-gold flex-shrink-0" data-id="element-42" />}
            </button>

            <AnimatePresence data-id="element-43">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-44">
                  <div className="px-6 pb-5 text-prime-textMuted leading-relaxed border-t border-white/5 pt-4" data-id="element-45">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
};